export default angular
  .module('gm.wealth.common')
  .filter('gmwAddPeriod', gmwAddPeriod)
  .name;

function gmwAddPeriod() {
  'ngInject';

  return addPeriod;

  function addPeriod(input) {
    if (!input) {
      return input;
    }
    return `${input.replace(/\.\s*$/, '')}.`;
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/add-period.js